import React from "react";
import {ApiResponse} from "@models/axios";
import {Category} from "@models/category";
import {Tag} from "@models/tag";
import {FormattedMessage} from 'react-intl';
import {PersonRole} from "@models/person-role";
import {Person} from "@models/person";
import {Image} from "@models/image";
import __i18n from "../intl/__i18n";

export const enum VideoContentType {
  "UNSPECIFIED" = "unspecified",
  "SINGLE" = "single_video",
  "CONTENT_LIST" = "video_content_list",
  "SERIES" = "series",
  "SEASON" = "season_of_series",
  "EPISOD" = "episode"
}

export const enum VideoContentAgeRestrictionType {
  "NOTSET" = "not_set",
  "TODDLERS" = "toddlers",
  "THREE" = "three",
  "SEVEN" = "seven",
  "TWELVE" = "Twelve",
  "THIRTEEN" = "thirteen",
  "FIFTEEN" = "fifteen",
  "EIGHTEEN" = "eighteen",
  "ADULT" = "adult"
}

export const enum VideoContentFlag {
  "None" = "none",
  "InProduction" = "in_production",
  "ComingSoon" = "coming_soon",
  "HasSubtitle" = "has_subtitle",
  "PersianDub" = "persian_dub",
  "HD" = "hd",
  "TrafficFree" = "traffic_free",
  "_4K" = "_4_k",
  "Hidden" = "hidden",
  "Downloadable" = "downloadable",
  "CinemaOnline" = "cinema_online",
  "MultiAudio" = "multi_audio",
  "ExclusiveDub" = "exclusive_dub",
  "HasSurvey" = "HasSurvey",
  "AudioBook" = "audio_book",
  "LiveStream" = "live_stream",
  "DeafSubtitle" = "has_deaf_subtitle",
  "TheaterFilm" = "theater_film",
  "SilentFilm" = "silent_film",
}


export const VideoContentFlagOptions = [{
  label: <FormattedMessage id="app.in_production" defaultMessage={`In Production`}/>,
  value: VideoContentFlag.InProduction
}, {
  label: <FormattedMessage id="app.coming_soon" defaultMessage={`Coming Soon`}/>,
  value: VideoContentFlag.ComingSoon
}, {
  label: <FormattedMessage id="app.has_sub_title" defaultMessage={`Has Sub Title`}/>,
  value: VideoContentFlag.HasSubtitle
}, {
  label: <FormattedMessage id="app.persian_dubbing" defaultMessage={`Persian Dubbing`}/>,
  value: VideoContentFlag.PersianDub
}, {
  label: <FormattedMessage id="app.hd" defaultMessage={`HD`}/>,
  value: VideoContentFlag.HD
}, {
  label: <FormattedMessage id="app.trafic_free" defaultMessage={`Traffic Free`}/>,
  value: VideoContentFlag.TrafficFree
}, {
  label: <FormattedMessage id="app.hidden" defaultMessage={`Hidden`}/>,
  value: VideoContentFlag.Hidden
}, {
  label: <FormattedMessage id="app.4k" defaultMessage={`4K`}/>,
  value: VideoContentFlag._4K
}, {
  label: __i18n("Cinema Online"),
  value: VideoContentFlag.CinemaOnline
}, {
  label: __i18n("multi_audio"),
  value: VideoContentFlag.MultiAudio
}, {
  label: __i18n("exclusive_dub"),
  value: VideoContentFlag.ExclusiveDub
}, {
  label: __i18n("HasSurvey"),
  value: VideoContentFlag.HasSurvey
}, {
  label: __i18n("AudioBook"),
  value: VideoContentFlag.AudioBook
}, {
  label: <FormattedMessage id="app.live_stream" defaultMessage={`Live Stream`}/>,
  value: VideoContentFlag.LiveStream
}, {
  label: <FormattedMessage id="app.deaf_subtitle" defaultMessage={`Deaf Subtitle`}/>,
  value: VideoContentFlag.DeafSubtitle
}, {
  label: <FormattedMessage id="app.theater_film" defaultMessage={`Theater Film`}/>,
  value: VideoContentFlag.TheaterFilm
}, {
  label: <FormattedMessage id="app.silent_film" defaultMessage={`Silent Film`}/>,
  value: VideoContentFlag.SilentFilm
}];


export const enum VideoContentStatus {
  "NONE" = "none",
  "ACTIVE" = "active",
  "INACTIVE" = "inactive",
  "HIDE_LIST_CONTENT" = "hide_list_of_content",
}

export const VideoContentStatusOptions = [{
  value: VideoContentStatus.NONE,
  label: <FormattedMessage id="app.none" defaultMessage={`None`}/>
}, {
  value: VideoContentStatus.ACTIVE,
  label: <FormattedMessage id="app.active" defaultMessage={`Active`}/>
}, {
  value: VideoContentStatus.INACTIVE,
  label: <FormattedMessage id="app.inactive" defaultMessage={`Inactive`}/>
}, {
  value: VideoContentStatus.HIDE_LIST_CONTENT,
  label: <FormattedMessage id="app.hide_list_of_content" defaultMessage={`Hide list of content`}/>
}];

//
// export const enum VideoSortStrategy {
//     "IMDB_RANK" = "imdb_rank",
//     "RATE" = "rate",
//     "PUBLISH_DATE" = "publish_date",
// }
//
// export const VideoContentSortStrategyOptionsOptions = [{
//     value: VideoSortStrategy.IMDB_RANK,
//     label: <FormattedMessage id="app.imdb_rand" defaultMessage={`IMDB Rank`}/>
// }, {
//     value: VideoSortStrategy.RATE,
//     label: <FormattedMessage id="app.rate" defaultMessage={`Rate`}/>
// }, {
//     value: VideoSortStrategy.PUBLISH_DATE,
//     label: <FormattedMessage id="app.publish_date" defaultMessage={`Publish Date`}/>
// }];


export const enum VideoContentSortOrder {
  "DEFAULT" = "default",
  "LATEST" = "latest",
  "MOST_VISITED" = "most_visited",
  "BEST_SELLING" = "best_selling",
  "RATE" = "rate"
}

export const VideoContentSortOrderOptions = [{
  value: VideoContentSortOrder.DEFAULT,
  label: <FormattedMessage id="app.default" defaultMessage={`Default`}/>
}, {
  value: VideoContentSortOrder.BEST_SELLING,
  label: <FormattedMessage id="app.best_selling" defaultMessage={`Best Selling`}/>
}, {
  value: VideoContentSortOrder.LATEST,
  label: <FormattedMessage id="app.latest" defaultMessage={`Latest`}/>
}, {
  value: VideoContentSortOrder.MOST_VISITED,
  label: <FormattedMessage id="app.most_visited" defaultMessage={`Most Visited`}/>
}, {
  value: VideoContentSortOrder.RATE,
  label: <FormattedMessage id="app.rate" defaultMessage={`Rate`}/>
}];


export interface VideoContent extends ApiResponse {
  id: string,
  short_id: string,
  poster_image_id: string,
  type: VideoContentType,
  age_restriction: VideoContentAgeRestrictionType,
  related_video_content_id: string | null,
  flag: VideoContentFlag,
  year: number | null,
  imdb_rank_percent: number | null,//min = 0 & max = 100
  imdb_url: string,
  duration: string,
  status: VideoContentStatus,
  title: string,
  supper_title: string,
  sub_title: string,
  slug: string,
  summary: string,
  rate: number,////min = 0 & max = 50
  published_at: string,//date-tiem string
  cover_image_id: string,
  thumbnail_image_id: string,
  tags: Tag[],
  categories: Category[],
  video_content_person_roles: VideoContentPersonRole[],
  gallery: Gallery[],
  supplier_id: string;
  price: number;
  share: number;
  package_id: string
}

export interface Gallery {
  title: string;
  video_content_id: string;
  image_id: string;
  image: Image[];
  is_active: boolean;
  order: number;
  id: string;
  short_id: string;
  created_at: string;
  modified_at: string;
}


export interface VideoContentState {
  readonly loading: boolean
  readonly allIds: String[]
  readonly byId: object
  readonly count: number
}


export interface VideoContentPersonRole {
  person_role: PersonRole;
  person: Person;
  id: string,
  short_id: string,
}


export const VideoContentTypeOptions = [{
  value: VideoContentType.UNSPECIFIED,
  label: <FormattedMessage id="app.unspecified" defaultMessage={`Unspecified`}/>,
  relatedVideoContentType: null
}, {
  value: VideoContentType.SINGLE,
  label: <FormattedMessage id="app.single_video" defaultMessage={`Single Video`}/>,
  relatedVideoContentType: null
}, {
  value: VideoContentType.CONTENT_LIST,
  label: <FormattedMessage id="app.content_list" defaultMessage={`Bundle`}/>,
  relatedVideoContentType: null
}, {
  value: VideoContentType.SERIES,
  label: <FormattedMessage id="app.series" defaultMessage={`Series`}/>,
  relatedVideoContentType: null
}, {
  value: VideoContentType.SEASON,
  label: <FormattedMessage id="app.season" defaultMessage={`Season`}/>,
  relatedVideoContentType: VideoContentType.SERIES
}, {
  value: VideoContentType.EPISOD,
  label: <FormattedMessage id="app.episode" defaultMessage={`Episode`}/>,
  relatedVideoContentType: VideoContentType.SEASON
}];

export const VideoContentAgeRestrictionTypeOptions = [{
  value: VideoContentAgeRestrictionType.NOTSET,
  label: <FormattedMessage id="app.not_set" defaultMessage={`Not_Set`}/>,
  relatedVideoContentAgeRestrictionType: null
}, {
  value: VideoContentAgeRestrictionType.TODDLERS,
  label: <FormattedMessage id="app.toddlers" defaultMessage={`Toddlers`}/>,
  relatedVideoContentAgeRestrictionType: null
}, {
  value: VideoContentAgeRestrictionType.THREE,
  label: <FormattedMessage id="app.three" defaultMessage={`Three`}/>,
  relatedVideoContentAgeRestrictionType: null
}, {
  value: VideoContentAgeRestrictionType.SEVEN,
  label: <FormattedMessage id="app.seven" defaultMessage={`Seven`}/>,
  relatedVideoContentAgeRestrictionType: null
}, {
  value: VideoContentAgeRestrictionType.TWELVE,
  label: <FormattedMessage id="app.twelve" defaultMessage={`Twelve`}/>,
  relatedVideoContentAgeRestrictionType: null
}, {
  value: VideoContentAgeRestrictionType.THIRTEEN,
  label: <FormattedMessage id="app.thirteen" defaultMessage={`Thirteen`}/>,
  relatedVideoContentAgeRestrictionType: null
}, {
  value: VideoContentAgeRestrictionType.FIFTEEN,
  label: <FormattedMessage id="app.fifteen" defaultMessage={`Fifteen`}/>,
  relatedVideoContentAgeRestrictionType: null
}, {
  value: VideoContentAgeRestrictionType.EIGHTEEN,
  label: <FormattedMessage id="app.eighteen" defaultMessage={`Eighteen`}/>,
  relatedVideoContentAgeRestrictionType: null
}, {
  value: VideoContentAgeRestrictionType.ADULT,
  label: <FormattedMessage id="app.adult" defaultMessage={`Adult`}/>,
  relatedVideoContentAgeRestrictionType: null
}];

